import React, { createContext, useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [variant, setVariant] = useState("success");

  const showToast = (msg, type = "success") => {
    setMessage(msg);
    setVariant(type);
    setShow(true);
    setTimeout(() => setShow(false), 3000);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      {/* Global Toast */}
      <ToastContainer
        position="bottom-center"
        className="p-3"
        style={{ zIndex: 9999, position:'fixed' }}
      >
       <Toast
          show={show}
          onClose={() => setShow(false)}
          className="bg-primary text-white text-center"
          style={{ width: 'auto' }}
        >
          <Toast.Body>{message}</Toast.Body>
       </Toast>
      </ToastContainer>
    </ToastContext.Provider>
  );
};
